import { Outlet, createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { APP_ROUTES_TO } from "@/utils/routes";
import { searchValidator } from "@/utils/search-validator";

export const SettingsSearchSchema = z.object({
    slack: z.enum(["connected", "error"]).optional(),
});

export type SettingsSearch = z.infer<typeof SettingsSearchSchema>;

export type SlackOAuthStatus = NonNullable<SettingsSearch["slack"]>;

export const Route = createFileRoute(APP_ROUTES_TO.SETTINGS)({
    validateSearch: searchValidator(SettingsSearchSchema),
    component: SettingsLayout,
    staticData: {
        config: {
            title: "settings",
        },
    },
});

function SettingsLayout() {
    return <Outlet />;
}
